export default function Layout({ children }) {
  return (
    <>
      <div className="custom-container w-full relative flex flex-col justify-start items-center">
        <main className="pt-0 w-full">{children}</main>
      </div>
    </>
  );
}
